import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { StyledSwitchContainer, StyledLabelWrapper, StyledInput, StyledSlider } from './styled';

const Switch = forwardRef(({ name, checked, disabled, customStyle, onChange }, ref) => {
    return (
        <StyledSwitchContainer
            disabled={disabled}
            customStyle={customStyle}
        >
            <StyledLabelWrapper>
                <StyledInput
                    ref={ref}
                    name={name}
                    type="checkbox"
                    checked={checked}
                    onChange={onChange || (() => {})}
                />
                <StyledSlider />
            </StyledLabelWrapper>
        </StyledSwitchContainer>
    );
});

Switch.propTypes = {
    name: PropTypes.string,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    customStyle: PropTypes.array,
    onChange: PropTypes.func
};

Switch.defaultProps = {
    checked: false,
    disabled: false,
    onChange: undefined
};

export default React.memo(Switch);
